import { SingleLayout, MyOrganizations } from 'components';
import React from 'react';


/**
 * Home頁
 */

export const MyOrganizationsPage = () => {
  return (
    <SingleLayout>
      <MyOrganizations />
    </SingleLayout>
  );
};

MyOrganizationsPage.propTypes = {};
